import * as API from '../utilities/api';
// import { returnStatement } from '@babel/types';

export const CLEAR_SELECTED_DATE = 'CLEAR_SELECTED_DATE';
export const DATE_PAGE_NEXT = 'DATE_PAGE_NEXT';
export const DATE_PAGE_PREV = 'DATE_PAGE_PREV';
export const FETCH_DATES = 'FETCH_DATES';
export const RECEIVE_DATES = 'RECEIVE_DATES';
export const SELECT_DATE = 'SELECT_DATE';
export const SAVE_SLIDER_POSITION = 'SAVE_SLIDER_POSITION';
export const SET_EXTRA_LIFE = "SET_EXTRA_LIFE";
export const SET_EXTRA_LIFE_AUTO_COMPLETE = "SET_EXTRA_LIFE_AUTO_COMPLETE";

export function fetchDates(overwrite) {
  return (dispatch, getState) => {
    const state = getState();
    return new Promise((resolve, reject) => {
      if (state.date.futureAvailabilityData.length === 0 || overwrite) {
        API.getDates(state.bookingLocation.selectedLocationId)
          .then(result => {
            dispatch(receiveDates(result));
            resolve();
          })
          .catch(error => {
            console.error('Failed to get date info: ' + error);
            reject(error);
          });
      }
      else resolve();
    });
  };
}

export function receiveDates(dates) {
  return {
    type: RECEIVE_DATES,
    dates
  };
}

export function selectDate(date) {
  return {
    type: SELECT_DATE,
    date
  };
}

export function datePageNext() {
  return {
    type: DATE_PAGE_NEXT
  };
}

export function datePagePrev() {
  return {
    type: DATE_PAGE_PREV
  };
}

export function clearSelectedDate() {
  return {
    type: CLEAR_SELECTED_DATE
  };
}

export function saveSliderPosition(sliderPosition) {
  return {
    type: SAVE_SLIDER_POSITION,
    sliderPosition
  };
}

export function setExtraLife() {
  return {
    type: SET_EXTRA_LIFE,
  };
}

export function setExtraLifeAutoComplete(isAutoComplete) {
  return {
    type: SET_EXTRA_LIFE_AUTO_COMPLETE,
    isAutoComplete
  }
}